import Image from 'next/image';
import Link from 'next/link';
import React, { useState } from 'react';

import clsxm from '@/lib/clsxm';

import { useUser } from '@/utils/useUser';

import ButtonLink from '../links/ButtonLink';

const SpecialOfferLandingPageNavigation = () => {
  const { user } = useUser();
  const [isOpened, setIsOpened] = useState(false);

  return (
    <div>
      <div className='relative px-4 pt-6 sm:px-6 lg:px-8'>
        <nav
          className='relative flex items-center justify-between sm:h-10 lg:justify-start'
          aria-label='Global'
        >
          <div className='flex flex-shrink-0 flex-grow items-center'>
            <div className='flex w-full items-center justify-between md:w-auto'>
              <Link href='#' passHref>
                <Image
                  src='/images/marky.png'
                  width='250'
                  height='36'
                  className='text-2xl font-extrabold text-primary-700'
                  alt='Easy-Peasy.ai logo'
                />
              </Link>
              <div className='-mr-2 flex items-center md:hidden'>
                <button
                  type='button'
                  className='inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500'
                  aria-expanded='false'
                  onClick={() => setIsOpened(!isOpened)}
                >
                  <span className='sr-only'>Open main menu</span>
                  <svg
                    className='h-6 w-6'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    aria-hidden='true'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M4 6h16M4 12h16M4 18h16'
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div className='hidden md:ml-10 md:block md:space-x-8 md:pr-4'>
            <Link
              href='#features'
              className='font-medium text-gray-500 hover:text-gray-900'
            >
              Features
            </Link>
            <Link
              href='#pricing'
              className='font-medium text-gray-500 hover:text-gray-900'
            >
              Pricing
            </Link>
            <Link
              href='#faq'
              className='font-medium text-gray-500 hover:text-gray-900'
            >
              FAQ
            </Link>

            <ButtonLink variant='dark' href='#pricing'>
              Sign up
            </ButtonLink>
          </div>
        </nav>
      </div>

      <div
        className={clsxm(
          isOpened ? '' : 'hidden',
          'absolute inset-x-0 top-0 z-10 transform p-2 md:hidden',
        )}
      >
        <div className='overflow-hidden rounded-lg bg-white shadow-md ring-1 ring-black ring-opacity-5'>
          <div className='flex items-center justify-between px-5 pt-4'>
            <div>
              <span className=' text-2xl font-extrabold text-primary-700'>
                Easy-Peasy.AI
              </span>
            </div>
            <div className='-mr-2'>
              <button
                onClick={() => setIsOpened(!isOpened)}
                type='button'
                className='inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500'
              >
                <span className='sr-only'>Close main menu</span>
                <svg
                  className='h-6 w-6'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                  aria-hidden='true'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M6 18L18 6M6 6l12 12'
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className=' space-y-1 px-2 pt-2 pb-3'>
            <Link
              href='#features'
              className='block rounded-md px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900'
            >
              Features
            </Link>

            <Link
              href='#pricing'
              className='block rounded-md px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900'
            >
              Pricing
            </Link>

            <Link
              href='#faq'
              className='block rounded-md px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900'
            >
              FAQ
            </Link>

            <Link
              href='/contact'
              className='block rounded-md px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900'
            >
              Contact Us
            </Link>
          </div>

          <ButtonLink
            className='block w-full text-center'
            variant='dark'
            href='#pricing'
          >
            Sign up
          </ButtonLink>
        </div>
      </div>
    </div>
  );
};

export default SpecialOfferLandingPageNavigation;
